import React, { useState, useContext, useEffect } from "react";
import {
    Link,
    useHistory,
    useLocation
} from "react-router-dom";
import axios from "axios";
import { ConfigContext } from '../contexts/ConfigContext'

const SidebarItemIconAndLabel = ({ view }) => (
    <>
        <div class="sidebarIcon">
            <i class={`fas fa-${view.icon || "square"}`}></i>
        </div>
        <div class="sidebarLabel">{view.label}</div>
    </>
)

export default ({ logout, isMobile }) => {
    const location = useLocation();
    const config = useContext(ConfigContext);
    const history = useHistory();
    const [showMenu, setShowMenu] = useState(false);
    const [notificationBadges, setNotificationBadges] = useState({});

    const toggleMenu = () => setShowMenu(!showMenu);

    useEffect(() => {
        const closeMenu = (e) => {
            if (!e.target.closest('.menu') && !e.target.closest('.menuButton')) {
                setShowMenu(false);
            }
        };

        document.addEventListener('click', closeMenu);
        return () => document.removeEventListener('click', closeMenu);
    }, []);

    useEffect(() => {
        refreshData()

        if (config?.sidebar?.refreshInterval) {
            const interval = setInterval(refreshData, config.sidebar.refreshInterval)
            return () => clearInterval(interval)
        }
    }, []);

    const refreshData = () => {
        axios.get("/notificationBadges").then((response) => {
            setNotificationBadges(response.data)
        })
    }

    return (
        <div class="sidebar">
            {config.logo ? <img src={config.logo} class="logo" /> : null}
            <div class="sidebarTitle">{config.name}</div>
            <div class="sidebarSubtitle">Back-office</div>
            {config.views.map((view, i) => {
                if (view.hidden) {
                    return null;
                } else if (view.type === "link") {
                    return (
                        <a href={view.src} key={i}>
                            <div class="sidebarItem">
                                <div>
                                    <SidebarItemIconAndLabel view={view} />
                                </div>
                            </div>
                        </a>
                    )
                } else if (view.type === "iframe") {
                    const isActive = location.pathname === `/iframe/${i}`
                    return (
                        <Link to={`/iframe/${i}`} key={i}>
                            <div class={`sidebarItem ${isActive ? "active" : ""}`}>
                                <div>
                                    <SidebarItemIconAndLabel view={view} />
                                </div>
                            </div>
                        </Link>
                    )
                } else if (view.type === "custom") {
                    const isActive = location.pathname === `/customView/${i}`
                    return (
                        <Link to={`/customView/${i}`} key={i}>
                            <div class={`sidebarItem ${isActive ? "active" : ""}`}>
                                <div>
                                    <SidebarItemIconAndLabel view={view} />
                                </div>
                            </div>
                        </Link>
                    )
                } else if (view.type === "table") {
                    const isActive =
                        location.pathname === `/records/${i}` ||
                        location.pathname === `/createRecord/${i}` ||
                        location.pathname.startsWith(`/record/${i}/`) ||
                        location.pathname.startsWith(`/editRecord/${i}/`)
                    return (
                        <div onClick={() => history.push(`/records/${i}`)} key={i}>
                            <div class={`sidebarItem ${isActive ? "active" : ""}`}>
                                <div>
                                    {notificationBadges[view.__id__] ? <div class="notificationWrapper">{notificationBadges[view.__id__]}</div> : null}
                                    <SidebarItemIconAndLabel view={view} />
                                </div>
                                {view.subviews ? (
                                    <>
                                        <div class="subviewsSeparator"></div>
                                        {view.subviews.map((subview, j) => {
                                            const isActive = location.pathname == `/records/${i}/${j}`
                                            return (
                                                <div onClick={(e) => {
                                                    history.push(`/records/${i}/${j}`);
                                                    e.stopPropagation();
                                                }}>
                                                    <div data-subview-index={j} class={isActive ? "active" : ""}>
                                                        {notificationBadges[subview.__id__] ? <div class="notificationWrapperForSubview">{notificationBadges[subview.__id__]}</div> : null}
                                                        {subview.label}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </>
                                ) : null}
                            </div>
                        </div>
                    )
                }
            })}
            {!config.hideBranding ? (
                <div class="sidebarBranding">Made with <i class="fas fa-heart"></i> by Galadrim</div>
            ) : null}
            {!isMobile ? (
                <div class="menu" onClick={toggleMenu}>
                    <div class="menuButton">
                        <i class="far fa-ellipsis-v"></i>
                    </div>
                    {showMenu ? (
                        <div class="menuOptions">
                            <div onClick={logout} class="menuOption">
                                <i class="far fa-sign-out"></i> Se déconnecter
                            </div>
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
